import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import {
    motion,
} from "framer-motion"

const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  z-index: -1; /* Fixed typo: zindex -> z-index */
`;

const Video = styled.video`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: translate(-50%, -50%);
  z-index: -1;
`;

const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
  z-index: 1;
`;

const Title = styled.h1`
  font-size: 4rem;
  margin: 0;
`;
const Stylednew = styled.span`
    display: inline;
    -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
    @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

const Styledmobile = styled.div`
    width: 10.5vw;
    height: 3vw;
  overflow: hidden;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  display: flex;
  @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

const Styledmobile2 = styled(motion.div)`
 display: none;
   -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
    @media (max-width: 1200px) {
       width: 26vw;
  height: 8vw;
  overflow: hidden;
  display: flex;
    }
`;

const Stylednew1 = styled.span`
    display: inline;
    @media (min-width: 768px) and (max-width: 1200px) {
       display: none;
    }
    @media (max-width: 767px) {
        display: none;
    }
`;

const StyledImage = styled.img`
  height: 3.5vh;
  margin-bottom: 1.5vh;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  @media (max-width: 1200px) {
     display: none;
  }
`;

const StyledDiv = styled(motion.div)`
  display: flex;
  height: 3.5vw;
  align-items: end;
  width: auto;
   margin-bottom: 1vw;

`;

const StyledDiv1 = styled(motion.div)`
  display: flex;
  height: 3.5vw;
  align-items: end;
  width: auto;
`;

const Why = styled.div`
  font-size: 4.2vw;
  color: #fff;
  font-weight: 600;
  letter-spacing: 1px;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  font-family: "Darker Grotesque", sans-serif;
  line-height: 1;

   @media (min-width: 768px) and (max-width: 1200px) {
      font-size:  clamp(9vw, 6vw, 8vw);
      text-align: center;
    }
    @media (max-width: 767px) {
    font-size:  clamp(9vw, 6vw, 8vw);
    text-align: center;
    }
`;

const Teamdiv = styled.div`
  width: 3vw;
  height: 3vw;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  border-radius: 3vw;
   @media (min-width: 768px) and (max-width: 1200px) {
        width: 8vw;
        height: 8vw;
        border-radius: 4vw;
    }
`;

const Teamdiv1 = styled.div`
  width: 3vw;
  height: 3vw;
  border-radius: 3vw;
  -webkit-user-select: none; 
  -moz-user-select: none; 
  -ms-user-select: none; 
  user-select: none;
  margin-left: -0.5vw;
   @media (min-width: 768px) and (max-width: 1200px) {
        width: 8vw;
        height: 8vw;
        border-radius: 4vw;
        margin-left: -2vw;
    }
`;


const StyledImage1 = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;


const VideoBackground = () => {
    const [hiddenClass, setHiddenClass] = useState('');
  const [hiddenClassmobile, setHiddenClassmobile] = useState('');
  
  // Check if device is mobile
  const checkMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
    const isSmallScreen = window.innerWidth <= 768;
    return isMobileDevice || isSmallScreen;
  };

  const [showSplitscreen, setShowSplitscreen] = useState(() => {
    // Skip splitscreen on mobile
    if (checkMobile()) {
        return false;
    }
    return sessionStorage.getItem("splitscreen_shown") ? false : true;
});
  useEffect(() => {
      window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
      const handleResize = () => {
          if (window.innerWidth < 1200) {
              setHiddenClass('hidden');
          } else {
              setHiddenClass('');
          }
      };

      window.addEventListener('resize', handleResize);
      handleResize(); // Initial check

      return () => {
          window.removeEventListener('resize', handleResize);
      };
  }, []);

  useEffect(() => {
      const handleResizemobile = () => {
          if (window.innerWidth < 480) {
              setHiddenClassmobile('hidden');
          } else {
              setHiddenClassmobile('');
          }
      };

      window.addEventListener('resize', handleResizemobile);
      handleResizemobile(); // Initial check

      return () => {
          window.removeEventListener('resize', handleResizemobile);
      };
  }, []);
  return (
    <VideoContainer style={{backgroundColor:'#000'}}>
      <Video autoPlay loop muted>
        <source src='https://genzixbackend.s3.ap-south-1.amazonaws.com/hero4.mp4' type="video/mp4" />
        Your browser does not support the video tag.
      </Video>
      <div style={{position: 'absolute', zIndex: '2', color: 'orange', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                    {
                      hiddenClass ? (
                        <StyledDiv 
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, ease: "easeOut", delay: showSplitscreen ? 12 : 0 }} 
                        style={{ width:'120%'}}
                    >
                        <Why>Ignite your digital{"\n"}presence with us</Why>
                    </StyledDiv>
                    
                      ):(
                        <StyledDiv initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7, ease: "easeOut",delay: showSplitscreen ? 12 : 0 }} style={{ marginTop: hiddenClass ? (hiddenClassmobile ? '-5vh' : '-13vh') : '-10vh' }}>
                        <Why >Ignite your <Stylednew >digital</Stylednew></Why>
                    </StyledDiv>
                      )
                    }

                    {hiddenClass ? (
                      <></>
                    ) : (
                        <StyledDiv1 initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, ease: "easeOut", delay: showSplitscreen ? 12: 0  }}>
                            <Why > presence<span className="space why"></span></Why>
                            <Why><Stylednew1 ></Stylednew1>with us<span className="space "></span></Why>

                        </StyledDiv1>
                    )}
                </div>
                {showSplitscreen ? (
  <></>
) : (
  hiddenClass ? (
    <></>
  ) : (
    <div style={{position:'absolute', bottom:'1.5vw', left:'1.5vw', display:'flex', flexDirection:'column', alignItems:'flex-start', gap:'1vw'}}>
      <div><img src='https://genzixbackend.s3.ap-south-1.amazonaws.com/img8.webp' alt="Card 1 design " style={{width:'8vw', height:'5vw'}} /></div>
      <div><img src='https://genzixbackend.s3.ap-south-1.amazonaws.com/img.webp' alt="Card 2 design" style={{width:'8vw', height:'5vw'}} /></div>
      <div><img src='https://genzixbackend.s3.ap-south-1.amazonaws.com/4.webp' alt="Card 3 design" style={{width:'8vw', height:'5vw'}} /></div>
    </div>
  )
)}

                
    </VideoContainer>
  );
};

export default VideoBackground;